<template>
    <div class="fullHeight">
        <MypageSideMenu @set="initialize" :memberDropClose="false"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info mypage-title-icon"
            >
            <div class="col-sm-12">
                <p>携帯番号の変更が完了しました。</p>
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        Card
    },
    data () {
        return {
            page_title: '携帯番号変更完了'
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize () {
        }
    }
}

</script>

<style scoped>
.sp_label{
    display: none;
}

@media screen and (max-width: 896px) {
    .mypage_mainwindow{
       width: 98%;
       margin: 0 auto;
       -ms-overflow-style: none;
       scrollbar-width: none;
    }

    .mypage_mainwindow::-webkit-scrollbar {
        display:none;
    }

    .sp_label {
        display: inline-block;
        min-width: 6rem;
        font-weight: 600;
    }

    .side_display_none{
        display: none;
    }

    @media screen and (max-width: 650px) {
        .display-table td{
            font-size: 14px;
        }
    }
}
</style>
